export enum ResStatus {
  Draft = "Draft",
  Archived = "Archived",
  Published = "Published"
}
